(function ($) {
    $('body').on('click', '.react-datepicker__day', function () {
        $('.numberWithPlusMinus').css("display", "grid");
        $('.subgroupWrapper.recras-product_with_time').css("display", "flex");
    });
})(jQuery);